import { useEffect, useState } from "react";
import { Box, Button, Image, Text, useDisclosure } from "@chakra-ui/react";
import { getApi, deleteApi } from "common/services/api";
import { HasAccess } from "../../../../common/utils/accessUtils";
import CommonCheckTable from "common/components/checktable";
import { SearchIcon } from "@chakra-ui/icons";
import { useLocation, useNavigate } from "react-router-dom";
import CommonDeleteModel from "common/components/commonDeleteModel";
import { toast } from "react-toastify";
import viewIcon from "common/assets/img/viewIcon.png";
import editIcon from "common/assets/img/editIcon.png";
import { constant } from "common/constant";
import { globalStyles } from "common/theme/styles";
import { referralsData } from "services/Recruit/data/referrals";
import { recruitConstant } from "services/Recruit/constant";
import deleteIcon from "common/assets/img/deleteIcon.png";
const Referals = () => {
  const title = recruitConstant.createReferral;
  const [action, setAction] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [deleteMany, setDeleteMany] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState(referralsData);
  const [searchboxOutside, setSearchboxOutside] = useState("");
  const [displaySearchData, setDisplaySearchData] = useState(false);
  const [searchedData, setSearchedData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const colors = globalStyles.colors;

  const [permission] = HasAccess(["Tasks", "Leads", "Contacts"]);

  const actionHeader = {
    Header: recruitConstant.actions,
    isSortable: false,
    center: true,
    cell: ({ row }) => (
      <Text fontSize="md" fontWeight="900" textAlign={"center"}>
        <Box className="actionCellContainer">
          {/* {permission?.view && (
            <Image
              onClick={() =>
                navigate(`/recruit/referralsCreate/${row?.values?.id}`)
              }
              src={viewIcon}
              h={"20px"}
              w={"20px"}
            />
          )} */}
          {permission?.update && (
            <Image
              onClick={() =>
                navigate(`/recruit/referralsCreate/${row?.values?.id}`)
              }
              src={editIcon}
              h={"20px"}
              w={"20px"}
            />
          )}
                  {permission?.delete && (
            <Box className="toolTipBox">
            <Image
             onClick={() => {
              setDeleteMany(true);
              setSelectedValues([row?.values?.id]); 
            }}
              src={deleteIcon}
              h={"20px"}
              w={"20px"}
            />
            <Text className="toolTip">{constant.delete}</Text>
            </Box>
          )}
        </Box>
      </Text>
    ),
  };

  const tableColumns = [
    { Header: "#", accessor: "id", 
      isSortable: false, width: 10 },
    { Header: recruitConstant.candidateName,
      accessor: "candidateName" 
    },
    { Header: recruitConstant.jobtitle,
      accessor: "jobtitle" 
    },
    { Header: recruitConstant.referredBy,
      accessor: "referredBy" 
    },
    { Header: recruitConstant.experience,
      accessor: "experience" 
    },
    { Header: recruitConstant.currentEmployer,
      accessor: "currentEmployer" 
    },
    ...(permission?.update || permission?.view || permission?.delete
      ? [actionHeader]
      : []),
  ];

  const handleDeleteProfile = async (ids) => {
    const updatedData = tableData.filter((item) => !ids.includes(item.id));
    setTableData(updatedData);
    setSelectedValues([]);
    setDeleteMany(false);
    toast.success(recruitConstant.deleteMsg);
  };

  const [columns, setColumns] = useState([...tableColumns]);
  const [selectedColumns, setSelectedColumns] = useState([...tableColumns]);

  const dataColumn = tableColumns.filter((item) =>
    selectedColumns.some((column) => column.Header === item.Header)
  );

  return (
    <div>
      <CommonCheckTable
        title={title}
        isLoading={isLoading}
        columnData={columns}
        dataColumn={dataColumn}
        allData={tableData}
        tableData={tableData}
        searchDisplay={displaySearchData}
        setSearchDisplay={setDisplaySearchData}
        searchedDataOut={searchedData}
        setSearchedDataOut={setSearchedData}
        access={permission}
        action={action}
        setAction={setAction}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        isOpen={isOpen}
        onClose={onClose}
        state={location.state}
        onOpen={onOpen}
        selectedValues={selectedValues}
        setSelectedValues={setSelectedValues}
        setDelete={setDeleteMany}
        AdvanceSearch={
          <Button
            variant="outline"
            className="advance-search-button"
            colorScheme="brand"
            leftIcon={<SearchIcon />}
            mt={{ sm: "5px", md: "0" }}
            size="sm"
            onClick={() => console.log("Advance Search Clicked")}
          >
            {recruitConstant.advanceSearch}
          </Button>
        }
        setSearchboxOutside={setSearchboxOutside}
        searchboxOutside={searchboxOutside}
      />

      <CommonDeleteModel
        isOpen={deleteMany}
        onClose={() => setDeleteMany(false)}
        type={recruitConstant.referrals}
        handleDeleteData={handleDeleteProfile}
        ids={selectedValues}
      />
    </div>
  );
};

export default Referals;
